import React from "react"
import ModalBS from "react-bootstrap/Modal"
import { styled } from "styled-components"
import Modal, { CancelButton, OkButton } from "."
import { downloadFile } from "../../backendServices/backendServices"
import branding from "../../branding/branding"
import { QrCodeEntityType } from "../../globalStates/ExhibitorDataTypes"
import ErrorIcon from "../../images/error.svg"

const StyledBody = styled(ModalBS.Body)`
    display: flex;
    flex-direction: column;
    justify-content: center;

    & label {
        text-align: center;
    }
`

const StyledFooter = styled(ModalBS.Footer)`
    justify-content: center;

    & button {
        width: auto;
        min-width: 200px;
    }
`

const ImageContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 30px;

    img {
        height: 200px;
        width: 200px;
    }
`

interface ModalQrCodeProps {
    entityType: QrCodeEntityType
    name?: string
    url?: string
    visible: boolean
    onClose: () => void
}

const ModalQrCode: React.FC<ModalQrCodeProps> = ({ entityType, name, url, visible, onClose }) => {
    const title = name
        ? branding.configuration.qrCodes.modalTitle.replace("{$item}", name ?? "")
        : branding.configuration.qrCodes.errorTitle

    return (
        <Modal title={title} titleSize="h6" name="qrcodemodal" visible={visible} onClose={onClose}>
            <StyledBody>
                <ImageContainer>
                    <img src={url ?? ErrorIcon} alt="" />
                </ImageContainer>

                {!url && <label>{branding.configuration.qrCodes.errorMessage}</label>}
            </StyledBody>
            <StyledFooter>
                <CancelButton name="cancel" label={branding.configuration.qrCodes.cancelButtonText} onCancel={onClose} />
                {url && (
                    <OkButton
                        name="download"
                        label={branding.configuration.qrCodes.downloadButtonText}
                        onOk={() => {
                            downloadFile(
                                url,
                                `${entityType}-${name?.replaceAll(" ", "-")}.${branding.configuration.qrCodes.format}`
                            )

                            onClose()
                        }}
                    />
                )}
            </StyledFooter>
        </Modal>
    )
}

export default ModalQrCode
